module.exports = __webpack_public_path__ + "img/download-lg.a1e2bfc2.svg";